import { isCampaignGroupEnabled } from './isCampaignGroupEnabled';
import { realtimeReportVisibilityCondition } from './realtimeReportVisibilityCondition';

export const isCampaignGroupRealtimeVisible = props =>
    isCampaignGroupEnabled(props) && realtimeReportVisibilityCondition(props);
